module.exports = __webpack_public_path__ + "static/domky2.ee7050f0.png";